import PaymentSystemModel from 'Root/models/PaymentSystemModel';
import RegionModel from 'Root/models/RegionModel';

export const ABTestPaymentSystemGroupA = function () {
  return {
    id: PaymentSystemModel.STRIPE.id,
    pic: 'visa-and-mastercard.svg',
    title: 'Visa or Mastercard',
    enabled: true,
    mulModifier: PaymentSystemModel.METHODS.CARD.mulModifier,
    firstPurchaseMulModifier: PaymentSystemModel.METHODS.CARD.firstPurchaseMulModifier,
    regions: [
      RegionModel.EU.id,
      RegionModel.USA.id,
    ],
  };
};

export const ABTestPaymentSystemGroupB = function () {
  return {
    id: PaymentSystemModel.ECOMMPAY.id,
    pic: 'visa-and-mastercard.svg',
    title: 'Visa or Mastercard',
    enabled: true,
    mulModifier: PaymentSystemModel.METHODS.ECOMMPAY.mulModifier,
    regions: [
      RegionModel.EU.id,
      RegionModel.USA.id,
    ],
  };
};
